import styled from "styled-components";
import Switch from "@mui/material/Switch";

export const ToggleTitleWrapper = styled.div`
  text-align: left;
  font: ${({ main }) => {
    if (main) return "normal normal 550 13px/18px Open Sans;";
    else return "normal normal 500 13px/18px Open Sans;";
  }};
  letter-spacing: 0px;
  color: black;
  opacity: 1;
  align-items: center;
`;

export const ToggleSwitch = styled(Switch)`
  &.MuiSwitch-root {
    width: 34px;
    height: 19px;
    padding: 3px;
  }
  & span {
    &.MuiSwitch-thumb {
      width: 12px;
      height: 12px;
      margin-top: -6px;
      margin-left: -8px;
    }
  }
`;
